import { IVehicle } from '../../../../schema/Vehicle.ts';
import { VehicleBadge } from '../../../ui/Badge.tsx';

export function NoOperation(props: Readonly<{ vehicle: IVehicle }>) {
  return (
    <div className={'d-flex gap-3 align-items-center'}>
      <VehicleBadge vehicle={props.vehicle} />
      <p className={'card-text'}>{props.vehicle.display_identifier}</p>
    </div>
  );
}
